var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcPause = function SvgIcPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 23H15c-.8 0-1.4-.6-1.4-1.4V2.4c-.1-.8.6-1.4 1.4-1.4h5.9c.8 0 1.4.6 1.4 1.4v19.1c0 .9-.6 1.5-1.4 1.5zM9 23H3.1c-.8 0-1.4-.6-1.4-1.4V2.4c0-.8.6-1.4 1.4-1.4H9c.8 0 1.4.6 1.4 1.4v19.1c.1.9-.6 1.5-1.4 1.5z"
  })));
};
export default SvgIcPause;